export default __webpack_public_path__ + "static/media/logo.46d5f8c5.svg";